<script setup>
import { ref } from "vue";

const props = defineProps({
  tab_list: {
    type: Array,
    required: true,
    default: [],
  },
});

const emit = defineEmits(["selected"]);

const tab_selected = ref(0);

const selectTab = (item) => {
  if (!item.show) {
    return;
  }
  tab_selected.value = item.id;
  emit("selected", tab_selected.value);
};
</script>

<template>
  <view class="YTTab">
    <div class="tabs_list flex_bt">
      <div class="tabs_list_item">
        <div
          :class="['tabs_item', tab_selected == item.id ? 'tab_active' : '']"
          v-show="item.show"
          v-for="(item, index) in tab_list"
          :key="index"
          @click="selectTab(item)"
          :style="{
            marginLeft: index === 0 ? '0' : '-50px',
            zIndex: tab_list.length - index,
          }"
        >
          <div>{{ item.title }}</div>
        </div>
      </div>

      <slot name="button_box"></slot>
    </div>
  </view>
</template>

<style lang="scss" scoped>
.YTTab {
  .tabs_list {
    border-bottom: 2px solid #e8ebf0;
    .tabs_list_item {
      display: flex;
      align-items: flex-end;
      .tabs_item {
        width: 180px;
        height: 52px;
        line-height: 52px;
        padding-left: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/tab_unSelected.png");
        background-size: 100% 100%;
        cursor: pointer;
      }
      .tab_active {
        height: 60px;
        line-height: 60px;
        background: url("https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/tab_selected.png") !important;
        background-size: 100% 100%;
        margin-bottom: -1px;
        color: #796cb4;
      }
    }
  }
}
</style>
